import React from 'react'
import { Footer } from 'antd/es/layout/layout'
import { Flex } from 'antd'

export default function PublicFooterXS () {
  return (
    <Footer style={{ backgroundColor: '#1a3544', color: '#fff', '--ant-layout-footer-padding': '12px 10px' }} >
      <Flex vertical gap='10px' align='center'>
        <Flex gap='60px'>
          <a style={{ color: '#FFF' }} href='https://laboxmedicale.fr/mentions-legales/' target='_blank' rel="noreferrer">Mentions légales</a>
          <a style={{ color: '#FFF' }} href='https://faq.laboxmedicale.com/'>FAQ</a>
        </Flex>
        <a href="mailto:contact@laboxmedicale.com">contact@laboxmedicale.com</a>
        <a style={cssCollectivité} href={'https://laboxmedicale.fr'} target='_blank' rel="noreferrer">Vous êtes une collectivité</a>
      </Flex>
    </Footer>
  )
}

const cssCollectivité = {
  fontWeight: 'bold',
  borderWidth: '2px',
  borderColor: '#FFF',
  color: '#FFF',
  borderStyle: 'solid',
  borderRadius: '25px',
  padding: '0.5em 13px',
  cursor: 'pointer'
}
